import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import * as moment from 'moment';
import 'rxjs/add/observable/interval';
import {MvtService} from '../../../common/services/mvt.service';
import {environment} from 'environments/environment';

@Component({
  selector: 'informo-pollution-alerts',
  templateUrl: './pollution-alerts.component.html',
  styleUrls: ['./pollution-alerts.component.scss']
})
export class PollutionAlertsComponent implements OnInit, OnDestroy {
  @HostBinding('class.expanded') expanded = false;
  alert: any = null;
  private subscription: Subscription;
  private sql = `
    SELECT * FROM \`${environment.carto.tablePrefix}.madrid_traffic_pollution_incidences\`
    ORDER BY level DESC
    LIMIT 1
  `;

  constructor(private mvtService: MvtService) {
    this.subscription = Observable.interval(60 * 1000).subscribe(() => {
      this.getPollution();
    });
  }

  ngOnInit() {
    this.getPollution();
  }

  toggleDetails() {
    this.expanded = !this.expanded;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private async getPollution() {
    const response = await this.mvtService.getSQLData(this.sql, undefined)
    if (!response) return

    this.alert = response.rows[0];

    if (this.alert) {
      const menu = document.querySelector('.toggle-menu-mobile');
      if (menu) {
        menu['style'].top = '100px';
      }

      // @ts-ignore
      this.alert.level = isNaN(parseInt(this.alert.level, null)) ? 5 : parseInt(this.alert.level, null);

      this.alert.start = this.alert.start
        ? moment.utc(this.alert.start).format('DD/MM/YYYY - HH:mm')
        : undefined;

      this.alert.finish = this.alert.finish
        ? moment.utc(this.alert.finish).format('DD/MM/YYYY - HH:mm')
        : undefined;

      this.alert.measuresList = this.alert.measures.split('\n');

      this.mvtService.updateAlertLevel(this.alert.level);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/pollution-alerts/pollution-alerts.component.ts